<template>
  <div class="d-flex py-1 pl-4 pr-1 camera-buttons">
    <v-btn rounded outlined icon color="error" class="mr-3" @click="dialog = true">
      <v-icon> mdi-phone-hangup </v-icon>
    </v-btn>

    <v-btn
      rounded
      outlined
      icon
      class="mr-3"
      :color="cameraError ? 'grey' : 'primary'"
      :disabled="Boolean(cameraError)"
      @click="
        changeTrackState({
          kind: 'video',
          action: tracksMuted.video ? 'unmute' : 'mute',
        })
      "
    >
      <v-icon>
        {{ tracksMuted.video ? "mdi-video-off" : "mdi-video" }}
      </v-icon>
    </v-btn>

    <div class="mic-btn-wrapper">
      <div class="tooltip caption grey white--text" v-if="showMuteTooltip">
        {{ $t('muted') }}
      </div>

      <v-btn
        rounded
        outlined
        icon
        :color="micError ? 'grey' : 'primary'"
        :disabled="Boolean(micError)"
        @click="
          changeTrackState({
            kind: 'audio',
            action: tracksMuted.audio ? 'unmute' : 'mute',
          })
        "
      >
        <v-icon>
          {{ tracksMuted.audio ? "mdi-microphone-off" : "mdi-microphone" }}
        </v-icon>
      </v-btn>
    </div>

    <div class="body-2 warning--text align-self-center ml-3">
      {{ micError }}
    </div>
  
    <!-- 🔳 Fullscreen Button -->
  <v-btn
  icon
  color="white"
  class="rounded-button"
  @click="toggleFullScreen"
>
  <v-icon color="black">
    {{ isFullScreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen' }}
  </v-icon>
</v-btn>


    <v-btn
      rounded
      outlined
      icon
      color="primary"
      class="ml-auto"
      @click="toggleChat(!chat)"
    >
      <v-icon>mdi-chat</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" max-width="500">
      <div class="white pa-3">
        <div class="body-1 text-center mb-4">
          {{ $t('leavePresentation') }}
        </div>

        <div class="d-flex justify-center">
          <v-btn rounded outlined color="error" depressed class="mr-3 custom-rounded-button" @click="onLeave"
            >{{ $t('leave') }}</v-btn
          >

          <v-btn rounded outlined color="primary" depressed class="custom-rounded-button" @click="dialog = false"
            >{{ $t('stay') }}</v-btn
          >
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import i18n from "../locales/i18n";
export default {
  data() {
    return {
      showMuteTooltip: false,
      dialog: false,
      isFullScreen: false,
    };
  },
  watch: {
    'tracksMuted.audio'(val) {
      if (val) {
        this.showMuteTooltip = true;
        setTimeout(() => {
          this.showMuteTooltip = false;
        }, 2000); // εμφανίζεται για 2 δευτερόλεπτα
      }
    },
  },
  computed: {
    ...mapState({
      tracksMuted: (state) => state.twilio.tracksMuted,
      cameraError: (state) => state.twilio.cameraError,
      micError: (state) => state.twilio.micError,
      chat: (state) => state.base.chat,
    }),
  },
  methods: {
    ...mapMutations(["toggleChat", "setAllowLeave"]),
    ...mapActions(["changeTrackState"]),
    onLeave() {
      this.setAllowLeave(true);

      this.$router.push({ path: `/${i18n.locale}` });
    },

     toggleFullScreen() {
    if (!this.isFullScreen) {
      const elem = document.documentElement;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  }
  },
  mounted() {
       // Παρακολουθεί αν μπήκε ή βγήκε από fullscreen
    document.addEventListener('fullscreenchange', () => {
      this.isFullScreen = !!document.fullscreenElement;
    });
  }
};
</script>

<style lang="scss" scoped>
.camera-buttons {
  border-top: 1px solid #e0e0e0;
}

.custom-rounded-button {
  border-radius: 50% !important;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 1.5em 1.5em !important;
}

.mic-btn-wrapper {
  position: relative;

  .tooltip {
    position: absolute;
    top: -30px;
    left: 50%;
    transform: translateX(-50%);
    padding: 1px 8px;
    border-radius: 3px;
    white-space: nowrap;
  }
}

.rounded-button {
  border: 2px solid #ccc;
  border-radius: 50% !important;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

</style>
